const ROUTES = {
  auth: {
    login: "/login",
    register_face: "/register_face",
  },
  dashboard: "/dashboard/home",
  monitoring: {
    streaming: "/monitoring/streaming",
    playback_video: "/monitoring/play-video",
  },
  live_monitoring: "/monitoring",
  report: {
    report_home: "/report/home",
    report_create: "/report/create",
    report_update: "/report/update",
    report_detail: "/report/detail/:id",
  },
  master_data: {
    permission_group: {
      permission_group_home: "/master-data/permission-group",
      permission_group_create: "/master-data/permission-group/create",
      permission_group_update: "/master-data/permission-group/update",
    },
    organization: {
      organization_home: "/master-data/organization",
      organization_create: "/master-data/organization/create",
      organization_update: "/master-data/organization/update",
    },
    jurisdiction_level: {
      jurisdiction_level_home: "/master-data/jurisdiction-level",
    },
    gender: {
      gender_home: "/master-data/gender",
    },
    operation_status: {
      operation_status_home: "/master-data/operation-status",
    },
    vehicle_type: {
      vehicle_type_home: "/master-data/vehicle-type",
    },
    blood_type: {
      blood_type_home: "/master-data/blood-type",
    },
    religion_type: {
      religion_type_home: "/master-data/religion-type",
    },
    marital_type: {
      marital_type_home: "/master-data/marital-type",
    },
    nationality_type: {
      nationality_type_home: "/master-data/nationality-type",
    },
    device_type: {
      device_type_home: "/master-data/device-type",
    },
    vehicle_fuel_type: {
      vehicle_fuel_type_home: "/master-data/vehicle-fuel-type",
    },
  },
  management_data: {
    RegisterFace: {
      register_face_home: "/management-data/register-face",
      register_face_create: "/management-data/register-face/create",
      register_face_update: "/management-data/register-face/update",
    },
    OperationPolice: {
      operation_police_home: "/management-data/operation-police",
      operation_police_create: "/management-data/operation-police/create",
      operation_police_update: "/management-data/operation-police/update",
    },
    watchlist: {
      watchlist_home: "/management-data/watchlist",
      watchlist_create: "/management-data/watchlist/create",
      watchlist_update: "/management-data/watchlist/update",
    },
    playback: {
      playback_home: "/management-data/master-playback",
      playback_create: "/management-data/master-playback/create",
      playback_update: "/management-data/master-playback/update",
    },
    streaming_device: {
      streaming_device_home: "/management-data/streaming-device",
      streaming_device_create: "/management-data/streaming-device/create",
      streaming_device_update: "/management-data/streaming-device/update",
    },
    docking_station: {
      docking_station_home: "/management-data/docking-station",
      docking_station_create: "/management-data/docking-station/create",
      docking_station_update: "/management-data/docking-station/update",
    },
    user_access: {
      user_access_home: "/management-data/user",
      user_access_create: "/management-data/user/create",
      user_access_update: "/management-data/user/update",
    },
  },
  inventory: {
    // bwc: {
    //   bwc_home: "/inventory/body-worn-camera",
    //   bwc_create: "/inventory/body-worn-camera/create",
    //   bwc_update: "/inventory/body-worn-camera/update",
    //   bwc_detail: "/inventory/body-worn-camera/detail",
    // },
    camera: {
      camera_home: "/inventory/camera",
      camera_create: "/inventory/camera/create",
      camera_update: "/inventory/camera/update",
      camera_detail: "/inventory/camera/detail",
    },
    vehicle: {
      vehicle_home: "/inventory/vehicle",
      vehicle_create: "/inventory/vehicle/create",
      vehicle_update: "/inventory/vehicle/update",
      vehicle_detail: "/inventory/vehicle/detail",
    },
  },
  log_activity: {
    log_activity_home: "/log-activity",
    log_activity_create: "/log-activity/create",
    log_activity_update: "/log-activity/update",
  },
  license: {
    license_home: "/license",
    license_detail: "license/detail",
  },
  configuration: {
    configuration_home: "/configuration",
  },
  profile: {
    information: "/profile/information",
    password: "/profile/password",
  },
};
export { ROUTES };
